import { joinChannel, leaveChannel } from './ws-actions';
import { getChannel } from '../services/ws-channel';

export const emitOpenPost = post => joinChannel(getChannel({ type: 'post', ...post }));
export const emitClosePost = post => leaveChannel(getChannel({ type: 'post', ...post }));

export const UPDATE_POST = 'post/UPDATE';
export const SOCKET_UPDATE_POST = 'update post';
export const updatePost = payload => ({
  type: UPDATE_POST,
  payload,
});



// WEBPACK FOOTER //
// ./app/actions/post-socket.js